import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/auth/login.vue';

import MainLayout from './layouts/main.vue';
import EmptyLayout from './layouts/empty.vue';
import Home from './views/home/index.vue';

//===========================嵌入式===============================
import DciAccessory from './views/dci/accessory/index.vue';//配件型号管理
import DciProduct from './views/dci/product/index.vue';//产品型号管理
import DciAccessoryStockIn from './views/dci/accessoryStockIn/index.vue';//配件入库管理
import DciAccessoryInout from './views/dci/accessoryInout/index.vue';//配件库存管理
import DciProductStockIn from './views/dci/productStockIn/index.vue';//产品入库管理
import DciProductInout from './views/dci/productInout/index.vue';//产品库存管理
import DciMaintainRegister from './views/dci/maintainRegister/index.vue';//维修登记
import DciMaintainAccept from './views/dci/maintainAccept/index.vue';//维修受理、初检
import DciMaintainConfirm from './views/dci/maintainConfirm/index.vue';//确认维修
import DciMaintaining from './views/dci/maintaining/index.vue';//维修处理
import DciMaintainFinish from './views/dci/maintainFinish/index.vue';//维修办结
// import DciMaintainSaleOrder from './views/dci/maintainSaleOrder/index.vue';//维修报价单
import DciSoftware from './views/dci/software/index.vue';//版本管理
import DciStationData from './views/dci/stationData/index.vue';//产品点位数据
import DciDataSet from './views/dci/dataset/index.vue'; //数据集设置
import AppTriggerIndex from './views/application/trigger/Index.vue';//触发器设置
import AppAlarmIndex from './views/application/alarm/Index.vue';//通知报警
import DciManage from './views/dci/manage/index.vue';//远程控制
import DciRemoteUpdate from './views/dci/remoteUpdate/index.vue';//远程更新


// import DciData from './views/dci/device/index--data.vue';
// import DciInout from './views/dci/inout/index.vue';
// import DciInoutDetail from './views/dci/inout/index--detail.vue';
// import DciAlarm from './views/dci/alarm/index.vue';
// import DciAlarmDetail from './views/dci/alarm/index--detail.vue';
// import DciFile from './views/dci/file/index.vue';
// import DciSoftwareDetail from './views/dci/software/index--detail.vue';
// import PhonePsw from './views/dci/password/index.vue';
// import Device from './views/dci/device/index.vue';
// import Group from './views/dci/group/index.vue';
// import WhiteList from './views/dci/whitelist/index.vue';
// import DciPlatform from './views/dci/platform/index.vue';
// import DciPlatformDetail from './views/dci/platform/index--detail.vue';


//===========================工控===============================
import SwIpcCode from './views/sw/ipccode/index.vue';//授权码管理
import SwIpcCodeDetail from './views/sw/ipccode/index--detail.vue';
import Station from './views/pn/station/index.vue';//站点信息
import StationDetail from './views/pn/station/index--detail.vue';
import Software from './views/sw/software/index.vue';//软件产品信息
import SwUpdateDetail from './views/sw/update/index--detail.vue';
import SwService from './views/sw/service/index.vue';
import PnManagement from './views/pn/manage/index.vue';//远程反控
import PnAlarmInform from './views/pn/alarm/index.vue';//报警管理
import PlatformNetwork from './views/pn/platformnetwork/index.vue';//实时数据
import PlatformStation from './views/pn/platformnetwork/platformstation.vue';//实时数据
import IpAccessory from './views/ipc/accessory/index.vue';//配件型号管理
import IpProduct from './views/ipc/product/index.vue';//产品型号管理
import IpAccessoryStock from './views/ipc/accessoryInout/index.vue';//配件库存管理
import IpProductStockIn from './views/ipc/productStockIn/index.vue';//产品入库管理
import IpProductInout from './views/ipc/productInout/index.vue';//产品库存管理




// import IpcAlarm from './views/pn/alarm/index.vue';
// import IpcAlarmDetail from './views/pn/alarm/index--detail.vue';
// import MsDocument from './views/ms/document/index.vue';
// import MsDocDetail from './views/ms/document/index--detail.vue';
import Server from './views/cp/server/index.vue';
import ServerStatus from './views/cp/server/index--status.vue';
import ServerStatusDetail from './views/cp/server/index--detail.vue';
import MsInout from './views/ms/inout/index.vue';
import MsGroup from './views/ms/group/index.vue';
import MsIndustrial from './views/ms/industrial/index.vue';
import MsIpcCode from './views/ms/ipccode/index.vue';
import MsSoftware from './views/ms/software/index.vue';
import MsUpDetail from './views/ms/software/index--detail.vue';
import MsInfo from './views/ms/info/index.vue';
import MsInfoDetail from './views/ms/info/index--detail.vue';
import SwCheck from './views/sw/check/index.vue';
import Exhibition from './views/exhibition/index.vue';
import DownloadList from './views/download/index.vue';
import SoftwareDetail from './views/download/software--detail.vue';
import VersionDetail from './views/download/version--detail.vue';
import AppControlIndex from './views/application/control/Index.vue';
import AppGroupIndex from './views/application/group/Index.vue';
import AppMessageIndex from './views/application/message/Index.vue';
import AppMessageShow from './views/application/message/Show.vue';


// import AppClientIndex from './views/application/client/Index.vue';

//===========================基础功能===============================

import Client from './views/cp/client/index.vue';//客户管理
import DciContract from './views/cp/dcicontract/index.vue';//嵌入式合同管理
import DciContractVirtual from './views/cp/dcicontractVirtual/index.vue';//嵌入式虚拟合同管理
import IpcContract from './views/cp/ipccontract/index.vue';//工控合同管理
import IpcContractVirtual from './views/cp/ipccontractVirtual/index.vue';//工控虚拟合同管理
import IpcContractDetail from './views/cp/ipccontract/index--detail.vue';//工控合同详情
import Platform from './views/cp/platform/index.vue';//平台管理
import PlatformDetail from './views/cp/platform/index--detail.vue';
import BasicMeasureUnit from './views/basic/measureUnit/index.vue';//计量单位管理
import BasicIpcFactor from './views/basic/factor/ipc/index.vue';//环境质量因子管理
import BasicDciFactor from './views/basic/factor/dci/index.vue';//污染源因子管理
import File from './views/basic/file/index.vue';//文件管理
import WikiDraft from './views/basic/wikiDraft/index.vue';//知识库-草稿箱
import WikiAudit from './views/basic/wikiAudit/index.vue';//知识库-审核库
import WikiPublish from './views/basic/wikiPublish/index.vue';//知识库-发布库
import PublishManage from './views/basic/publishManage/index.vue';//发布管理
import Publish from './views/basic/publish/index.vue';//发布页
import PublishDciViewSoftware from './views/basic/publish/view-publish-dcisoftware.vue';//嵌入式软件单独发布页
import PublishDciViewDetail from './views/basic/publishManage/view-detail.vue';//嵌入式发布管理链接知识库单独发布页
import PublishDciViewPublishDetail from './views/basic/publishManage/view-publish-detail.vue';//嵌入式发布管理自定义单独发布页
import BasicDingtalkconfig from './views/basic/dingtalkconfig/index.vue';//钉钉配置



//===========================系统管理===============================
import User from './views/sys/user/index.vue';
import SysDepartment from './views/sys/department/index.vue';
import SysRole from './views/sys/role/index.vue';
import Basic from './views/basic/basic/index.vue';//常量分类管理
import BasicData from './views/basic/basic/index--data.vue';//相关常量管理
// import SysWiki from './views/sys/wiki/index.vue';


Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    /* eslint-disable object-property-newline, object-curly-newline */
    { path: '/login', name: 'Login', component: Login },
    { path: '/exhibition', name: 'Exhibition', component: Exhibition },
    { path: '/dci/publish',  name: 'DciPublish', component: Publish, meta: { group: 0 } },
    { path: '/ipc/publish',  name: 'IpPublish', component: Publish, meta: { group: 1 } },
    { path: '/publishDciViewSoftware',  name: 'PublishDciViewSoftware', component: PublishDciViewSoftware },
    { path: '/publishDciViewDetail',  name: 'PublishDciViewDetail', component: PublishDciViewDetail },
    { path: '/publishDciViewPublishDetail',  name: 'PublishDciViewPublishDetail', component: PublishDciViewPublishDetail },
    {
      path: '/', component: MainLayout, children: [
        { path: '', name: 'Home', component: Home },
      ],
    },
    {
      path: '/download', component: EmptyLayout, children: [
        { path: 'list', name: 'DownloadList', component: DownloadList },
        { path: 'software/:ID', name: 'SoftwareDetail', component: SoftwareDetail },
        { path: 'version/:ID', name: 'VersionDetail', component: VersionDetail },
      ],
    },
    {
      path: '/cp', component: MainLayout, children: [
        { path: 'client', name: 'CpClient', component: Client },
        { path: 'platform', name: 'CpPlatform', component: Platform, meta: { keepAlive: true } },
        { path: 'platform/:ID', name: 'CpPlatformDetail', component: PlatformDetail },
        { path: 'server', name: 'CpServer', component: Server },
        { path: 'serverstatus', name: 'CpServerStatus', component: ServerStatus, meta: { keepAlive: true } },
        { path: 'serverstatus/:ID', name: 'CpServerStatusDetail', component: ServerStatusDetail },
        { path: 'dcicontract', name: 'CpDciContract', component: DciContract, meta: { keepAlive: true } },
        { path: 'dcicontractVirtual', name: 'CpDciContractVirtual', component: DciContractVirtual },
        { path: 'ipccontract', name: 'CpIpcContract', component: IpcContract, meta: { keepAlive: true } },
        { path: 'ipccontract/:ID', name: 'CpIpcContractDetail', component: IpcContractDetail },
        { path: 'ipccontractVirtual', name: 'CpIpcContractVirtual', component: IpcContractVirtual },
      ],
    },
    {
      path: '/pn', component: MainLayout, children: [
        { path: 'platformnetwork', name: 'PnPlatformNetwork', component: PlatformNetwork },
        { path: 'platformstation', name: 'PnPlatformStation', component: PlatformStation },
        { path: 'station', name: 'PnStation', component: Station, meta: { keepAlive: true } },
        { path: 'station/:ID', name: 'PnStationDetail', component: StationDetail },
        // { path: 'alarm/ipc', name: 'IpcAlarmInform', component: IpcAlarm, meta: { keepAlive: true } },
        // { path: 'alarm/ipc/:ID', name: 'IpcAlarmDetail', component: IpcAlarmDetail },
        { path: 'manage', name: 'PnManagement', component: PnManagement },
        { path: 'alarm', name: 'PnAlarmInform', component: PnAlarmInform},
        
      ],
    },
    {
      path: '/sw', component: MainLayout, children: [
        { path: 'software', name: 'Software', component: Software },
        { path: 'update/:ID', name: 'SwUpdateDetail', component: SwUpdateDetail },
        { path: 'check', name: 'SwCheck', component: SwCheck },
        { path: 'ipccode', name: 'SwIpcCode', component: SwIpcCode, meta: { keepAlive: true } },
        { path: 'ipccode/:ID', name: 'SwIpcCodeDetail', component: SwIpcCodeDetail },
        { path: 'service/:ID', name: 'SwService', component: SwService },
      ],
    },
    {
      path: '/ipc', component: MainLayout, children: [
        { path: 'accessory', name: 'IpAccessory', component: IpAccessory },
        { path: 'product', name: 'IpProduct', component: IpProduct },
        { path: 'accessoryInout', name: 'IpAccessoryStock', component: IpAccessoryStock },
        { path: 'productStockIn', name: 'IpProductStockIn', component: IpProductStockIn },
        { path: 'productInout', name: 'IpProductInout', component: IpProductInout },
      ],
    },
    {
      path: '/dci', component: MainLayout, children: [
        { path: 'accessory', name: 'DciAccessory', component: DciAccessory },
        { path: 'product', name: 'DciProduct', component: DciProduct },
        { path: 'accessoryStockIn', name: 'DciAccessoryStockIn', component: DciAccessoryStockIn },
        { path: 'accessoryInout', name: 'DciAccessoryInout', component: DciAccessoryInout },
        { path: 'productStockIn', name: 'DciProductStockIn', component: DciProductStockIn },
        { path: 'productInout', name: 'DciProductInout', component: DciProductInout },
        { path: 'maintainRegister', name: 'DciMaintainRegister', component: DciMaintainRegister },
        { path: 'maintainAccept', name: 'DciMaintainAccept', component: DciMaintainAccept },
        { path: 'maintainConfirm', name: 'DciMaintainConfirm', component: DciMaintainConfirm },
        { path: 'maintaining', name: 'DciMaintaining', component: DciMaintaining },
        { path: 'maintainFinish', name: 'DciMaintainFinish', component: DciMaintainFinish },
        // { path: 'maintainSaleOrder', name: 'DciMaintainSaleOrder', component: DciMaintainSaleOrder },
        { path: 'software', name: 'DciSoftware', component: DciSoftware },
        { path: 'stationData', name: 'DciStationData', component: DciStationData, meta: { keepAlive: true } },
        { path: 'dataset', name: 'DciDataSet', component: DciDataSet },
        { path: 'manage', name: 'DciManagement', component: DciManage },
        { path: 'remoteUpdate', name: 'DciRemoteUpdate', component: DciRemoteUpdate },


        
        
        
        // { path: 'dsdata/:ID', name: 'DciData', component: DciData },
        // { path: 'inout', name: 'DciInout', component: DciInout, meta: { keepAlive: true } },
        // { path: 'inout/:ID', name: 'DciInoutDetail', component: DciInoutDetail },
        // { path: 'alarm/dci', name: 'DciAlarmInform', component: DciAlarm, meta: { keepAlive: true } },
        // { path: 'alarm/dci/:ID', name: 'DciAlarmDetail', component: DciAlarmDetail },
        // { path: 'file',  name: 'DciFile', component: DciFile },
        // { path: 'software/:ID', name: 'DciSoftwareDetail', component: DciSoftwareDetail },
        // { path: 'password', name: 'DciPassword', component: PhonePsw },
        // { path: 'device', name: 'DciDevice', component: Device },
        // { path: 'group', name: 'DciGroup', component: Group },
        // { path: 'whiteList', name: 'DciWhiteList', component: WhiteList },
        // { path: 'platformhomepage/dci', name: 'DciRealtimeData', component: DciPlatform, meta: { keepAlive: true } },
        // { path: 'platformhomepage/dci/:ID', name: 'DciPointRealTimeData', component: DciPlatformDetail },
      ],
    },
    {
      path: '/ms', component: MainLayout, children: [
        { path: 'inout', name: 'MsInout', component: MsInout },
        { path: 'info', name: 'MsInfo', component: MsInfo, meta: { keepAlive: true } },
        { path: 'info/:ID', name: 'MsInfoDetail', component: MsInfoDetail },
        { path: 'group', name: 'MsGroup', component: MsGroup },
        { path: 'industrial', name: 'MsIndustrial', component: MsIndustrial },
        { path: 'ipccode', name: 'MsIpcCode', component: MsIpcCode },
        // { path: 'document', name: 'MsDocument', component: MsDocument, meta: { keepAlive: true } },
        // { path: 'document/:ID', name: 'MsDocDetail', component: MsDocDetail },
        { path: 'software', name: 'MsSoftware', component: MsSoftware, meta: { keepAlive: true } },
        { path: 'software/:ID', name: 'MsUpDetail', component: MsUpDetail },
      ],

    },
    {
      path: '/basic', component: MainLayout, children: [
        { path: 'basic', name: 'Basic', component: Basic },
        { path: 'basic/:ID', name: 'BasicData', component: BasicData },
        { path: 'measureunit', name: 'BasicMeasureUnit', component: BasicMeasureUnit },
        { path: 'ipcfactor', name: 'BasicIpcFactor', component: BasicIpcFactor },
        { path: 'dcifactor', name: 'BasicDciFactor', component: BasicDciFactor },  
        { path: 'dci/file',  name: 'DciFile', component: File, meta: { group: 0 } },
        { path: 'ipc/file',  name: 'MsDocument', component: File, meta: { group: 1 } },
        { path: 'dci/wikiDraft',  name: 'DciWikiDraft', component: WikiDraft, meta: { group: 0 } },
        { path: 'ipc/wikiDraft',  name: 'IpWikiDraft', component: WikiDraft, meta: { group: 1 } },
        { path: 'dci/wikiAudit',  name: 'DciWikiAudit', component: WikiAudit, meta: { group: 0 } },
        { path: 'ipc/wikiAudit',  name: 'IpWikiAudit', component: WikiAudit, meta: { group: 1 } },
        { path: 'dci/wikiPublish',  name: 'DciWikiPublish', component: WikiPublish, meta: { group: 0 } },
        { path: 'ipc/wikiPublish',  name: 'IpWikiPublish', component: WikiPublish, meta: { group: 1 } },
        { path: 'dci/publishManage',  name: 'DciPublishManage', component: PublishManage, meta: { group: 0 } },
        { path: 'ipc/publishManage',  name: 'IpPublishManage', component: PublishManage, meta: { group: 1 } },
        { path: 'dingtalkconfig', name: 'BasicDingtalkconfig', component: BasicDingtalkconfig },
      ],
    },
    {
      path: '/sys', component: MainLayout, children: [
        { path: 'user', name: 'SysUser', component: User },
        { path: 'department', name: 'SysDepartment', component: SysDepartment },
        { path: 'role', name: 'SysRole', component: SysRole },
        // { path: 'wiki', name: 'SysWiki', component: SysWiki },
      ],
    },
    {
      path: '/application',
      component: MainLayout,
      children: [
        // {
        //   path: 'client',
        //   name: 'AppClientIndex',
        //   component: AppClientIndex,
        // },
        {
          path: 'control',
          name: 'AppControlIndex',
          component: AppControlIndex,
        },
        {
          path: 'client/group',
          name: 'AppGroupIndex',
          component: AppGroupIndex,
        },
        {
          path: 'message',
          name: 'AppMessageIndex',
          component: AppMessageIndex,
        },
        {
          path: 'message/:id',
          name: 'AppMessageShow',
          component: AppMessageShow,
        },
        {
          path: 'alarm',
          name: 'AppAlarmIndex',
          component: AppAlarmIndex,
        },
        {
          path: 'trigger',
          name: 'AppTriggerIndex',
          component: AppTriggerIndex,
        },
      ],
    },
  ],
});
